import { LocationTypes } from '../constants';

const mapLocation = (prefix, location, request) => {
  if (!location) return;

  const value = location.value || location.airportCode;
  if (!value) return;

  if (location.locationType === LocationTypes.PORT_OF_DEPARTURE) {
    request[`${prefix}.departureCityId`] = value;
  } else if (!location.airportCode) {
    request[`${prefix}.geoIndex`] = value;
    if (location.featureClass) {
      request[`${prefix}.featureClass`] = location.featureClass;
    }
  }

  if (location.airportCode) request[`${prefix}.airportCode`] = location.airportCode;
  if (location.latitude) request[`${prefix}.latitude`] = location.latitude;
  if (location.longitude) request[`${prefix}.longitude`] = location.longitude;
};

const formatCheckAirAvailabilityRequest = (searchInputs, currentIndex) => {
  const request = {};
  const segment = searchInputs?.flightSegments?.[currentIndex];
  if (!segment) return request;
  request.departureDate = segment.departureDate;
  request.flightNumber = segment.flightNumber;
  request.airline = segment.carrierCode?.value;

  mapLocation('origin', segment.origin, request);
  mapLocation('destination', segment.destination, request);

  return request;
};

export default formatCheckAirAvailabilityRequest;
